import { of } from 'rxjs'
import { tap } from 'rxjs/operators'
import { showInviteUsersMessage } from '@/notifications/messages/inviteUsersMessage'
import { showTrialMessage } from '@/notifications/messages/trialMessage'
import { redirect } from '@/notifications/messages/redirect'

export const setMessage = (emit, routerPush) => notifications => {
  emit = emit('app:message:display')
  const notifications$ = of(notifications)

  notifications$.pipe(tap(showInviteUsersMessage(emit))).subscribe()

  notifications$.pipe(tap(showTrialMessage(emit))).subscribe()

  notifications$.pipe(tap(redirect(routerPush))).subscribe()
}
